import { useState, useEffect } from 'react';

export function useFrameCounter(videoRef: React.RefObject<HTMLVideoElement>) {
  const [currentFrame, setCurrentFrame] = useState(0);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateFrame = () => {
      const fps = 30; // Assuming 30fps
      const frame = Math.floor(video.currentTime * fps);
      setCurrentFrame(frame);
    };

    video.addEventListener('timeupdate', updateFrame);
    return () => video.removeEventListener('timeupdate', updateFrame);
  }, [videoRef]);

  return currentFrame;
}